import {
  takeLatest,
  take,
  fork,
  all,
  call,
  select,
  put,
  cancelled
} from 'redux-saga/effects'
import { injectSagas } from 'redux-saga-injector'
import * as R from 'ramda'

import {
  get
} from 'helpers/RequestUtil'

import {
  removeTables,
  updateTables,
} from 'containers/Entity/actions'

import {
  MOUNT,
  UNMOUNT,
  MODULE_NAME
} from './constants'

import {
  updateProductDetails,
  clearProductDetails,
  fetchProductDetailsStart,
  fetchProductDetailsSuccess,
  fetchProductDetailsError,
  startFetchProductDetails,
} from './actions'

import {
  clearPartnerSiteList,
  clearEditValue,
} from 'containers/Product/ProductMappingTable/actions'

import {
  clearTestList,
  clearTestProfiles,
  clearTestConfigNames,
} from 'containers/Product/FulcrumTestSuiteConfiguration/actions'

function* clear() {
  yield put(clearProductDetails())
  yield put(removeTables('details'))
  yield put(clearTestList())
  yield put(clearTestConfigNames())
  yield put(clearTestProfiles())
}

function* fetchProductDetails(id) {
  try {
    yield put(startFetchProductDetails())
    yield put(fetchProductDetailsStart())
    const data = yield call(get, `api/fulcrum/product/details/${id}`)
    const { result: { details } } = data
    yield put(updateTables(data))
    yield put(fetchProductDetailsSuccess())
    return details
  } catch (error) {
    yield put(fetchProductDetailsError(error))
  } finally {
    if (yield cancelled()) {
      yield call(clear)
    }
  }
}

function* handleMount(action) {
  const { id } = action
  yield put(clearPartnerSiteList())
  yield put(clearEditValue())
  yield call(clear)
  yield put(updateProductDetails(id))
  const details = yield call(fetchProductDetails, id)
}

function* handleUnmount() {
  yield put(clearPartnerSiteList())
  yield put(clearEditValue())
  yield call(clear)
}

function* watchMount() {
  yield takeLatest(MOUNT, handleMount)
}

function* watchUnmount() {
  yield takeLatest(UNMOUNT, handleUnmount)
}

function* saga() {
  yield all([
    fork(watchMount),
    fork(watchUnmount)
  ])
}

export default saga

injectSagas({ [ MODULE_NAME ]: saga })
